const NutrientLoading = () => {
  const NutrientLoadingData = [
    {
      "Source": "Inflows",
      "Phosphorus Mass (pounds)": "",
      "Nitrogen Mass (pounds)": "",
      "_isSubHeading": true,
    },
    {
      "Source": "Cherry Creek (CC-10)",
      "Phosphorus Mass (pounds)": Number(5033).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(40174).toLocaleString(),
    },
    {
      "Source": "Cottonwood Creek (CT-2)",
      "Phosphorus Mass (pounds)": Number(294).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(13693).toLocaleString(),
    },
    {
      "Source": "Precipitation",
      "Phosphorus Mass (pounds)": Number(136).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(2668).toLocaleString(),
    },
    {
      "Source": "Alluvial Groundwater",
      "Phosphorus Mass (pounds)": Number(1388).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(2573).toLocaleString(),
    },
    {
      "Source": "Total Inflows",
      "Phosphorus Mass (pounds)": Number(6851).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(59108).toLocaleString(),
      "_isTotal": true,
    },
    {
      "Source": "Outflows",
      "Phosphorus Mass (pounds)": "",
      "Nitrogen Mass (pounds)": "",
      "_isSubHeading": true,
    },
    {
      "Source": "Evaporation",
      "Phosphorus Mass (pounds)": Number(0).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(0).toLocaleString(),
    },
    {
      "Source": "Reservoir releases",
        "Phosphorus Mass (pounds)": Number(-2826).toLocaleString(),
        "Nitrogen Mass (pounds)": Number(-28225).toLocaleString(),
    },
    {
      "Source": "Total Outflows",
      "Phosphorus Mass (pounds)": Number(-2826).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(-28225).toLocaleString(),
      "_isTotal": true,
    },
    {
      "Source": "WY 2020 Change in Storage",
      "Phosphorus Mass (pounds)": Number(4025).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(30883).toLocaleString(),
      "_isSubHeading": true,
    },
  ];

   // Declare and configure request overview table
   const NutrientLoadingTable = new requestTable({
    container: "#nutrient-loading-table",
    filterEnabled: false,
    tableHeaders: {
      "Source": "Source",
      "Phosphorus Mass (pounds)": "Phosphorus Mass (pounds)",
      "Nitrogen Mass (pounds)": "Nitrogen Mass (pounds)",
    },
    tableActions: [],
    tableData: NutrientLoadingData,
  });
  NutrientLoadingTable.buildTable();
};


// Build pie chart
const NutrientBalance = () => {
  const InflowProportions = new Pie({
    container: '#inflow-pie-chart',
    widthScale: 1,
    heightScale: 1,
    innerRadius: 80,
    color: d3.scaleOrdinal(['rgb(2, 117, 216)', 'rgb(255,140,0)', 'rgb(92, 184, 92)', 'rgb(128,128,128)'], ),
    resultField: 'rvalue',
    categoryField: 'source',
    data: [
      { source: 'Cherry Creek', rvalue:68},
      { source: 'Cottonwood Creek', rvalue: 14},
      { source: 'Alluvial Groundwater', rvalue: 15},
      { source: 'Precipitation', rvalue: 3},
    ],
  }).draw();

};